module.exports = __webpack_public_path__ + "img/icon-duplication.6f861d54.svg";